import React from "react";
import Chart from "../../Chart";
import ExampleSparkline from "../../../../components/Chart/ExampleSparkline";

class SparklineExampleApplet extends Chart {

    render() {
        return <ExampleSparkline applet={this}
                          attributes={this.state.Attributes}
                          data={this.state.Data}
                          sx={this.state.sx}
                          enterpriseComponent={this.getEnterpriseComponent()} />;
    }

    state = {
        Name: "SparklineExampleApplet",
        Menu: {
            options: [
                {
                    displayValue: "Refresh",
                    value: "Refresh",
                },
            ],
        },
        Attributes: {
            Height: 80,
            PlotType: "line",
            Area: true,
            ShowTooltip: true,
            ShowHighlight: true,
        },
        Data: [],
    }
}

export default SparklineExampleApplet;
